var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9326 20.4691C12.9326 20.0245 13.293 19.6641 13.7376 19.6641H14.1984C14.643 19.6641 15.0034 20.0245 15.0034 20.4691V20.8366C15.0034 21.2811 14.643 21.6416 14.1984 21.6416H13.7375C13.293 21.6416 12.9326 21.2811 12.9326 20.8366V20.4691Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3484 6.53905C11.4864 6.21158 12.6642 6.04277 13.8484 6.03739C16.275 6.03739 17.8384 7.30905 17.8326 9.72989C17.8326 11.1182 17.2434 11.9466 16.03 13.1891L15.4992 13.7199C14.8987 14.2378 14.5625 14.998 14.5834 15.7907V17.0916H13.3059V15.7324C13.3059 14.6766 13.4867 13.9824 14.6067 12.8157L15.1375 12.2849C16.1467 11.2232 16.4384 10.7799 16.4384 9.77072C16.4384 7.99739 15.4059 7.26239 13.5742 7.26239C12.4848 7.27736 11.4014 7.42626 10.3484 7.70572V6.53905Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6734 25.7832H14.3267C20.3292 25.7768 25.1936 20.9124 25.2001 14.9099V13.0899C25.1936 7.08737 20.3292 2.22298 14.3267 2.21655H13.6734C7.67087 2.22298 2.80648 7.08737 2.80005 13.0899V14.9099C2.80648 20.9124 7.67087 25.7768 13.6734 25.7832ZM4.20005 13.0899C4.20327 7.85924 8.44274 3.61977 13.6734 3.61655H14.3267C19.5574 3.61977 23.7968 7.85924 23.8001 13.0899V14.9099C23.7968 20.1405 19.5574 24.38 14.3267 24.3832H13.6734C8.44274 24.38 4.20327 20.1405 4.20005 14.9099V13.0899Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.94aeda16ecc3532b4b38296e35aa41a9.svg";
export { ForwardRef as ReactComponent };